import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { CgGitFork } from "react-icons/cg";
import { AiFillStar } from "react-icons/ai";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={`${navColour ? "bg-black/80 backdrop-blur-md shadow-lg" : "bg-transparent"} border-b border-white/5 transition-all duration-300`}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="flex items-center text-brand font-black tracking-tighter text-xl uppercase">
          JL.
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
          className="border-0 focus:shadow-none"
        >
          <div className="space-y-1.5">
            <span className="block w-6 h-0.5 bg-white"></span>
            <span className="block w-6 h-0.5 bg-white"></span>
            <span className="block w-6 h-0.5 bg-zinc-500"></span>
          </div>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto items-center" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)} className="text-zinc-600 hover:text-white transition-colors uppercase text-sm font-bold tracking-widest px-4">
                Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/about" onClick={() => updateExpanded(false)} className="text-zinc-600 hover:text-white transition-colors uppercase text-sm font-bold tracking-widest px-4">
                About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/project" onClick={() => updateExpanded(false)} className="text-zinc-600 hover:text-white transition-colors uppercase text-sm font-bold tracking-widest px-4">
                Projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/resume" onClick={() => updateExpanded(false)} className="text-zinc-600 hover:text-white transition-colors uppercase text-sm font-bold tracking-widest px-4">
                Resume
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className="ml-4 flex items-center gap-3">
              <Button
                href="https://github.com/Crizneil/Jen-portfolio.git"
                target="_blank"
                className="bg-white text-black hover:bg-zinc-200 border-0 px-4 py-2 flex items-center gap-2 rounded-lg font-bold"
              >
                <CgGitFork /> <AiFillStar />
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
